import { useEffect, useState, useCallback } from   'react';
import { NavLink } from 'react-router-dom';
import SeccionPageHeader from "../../Utils/SeccionPageHeader";
import CargandoSpinner from "../../Utils/CargandoSpinner";
import { Tooltip } from 'react-tooltip';
import apiService from './../../../Auth/apiService';
import { useAuth } from '../../../Auth/AuthContext';
import { FaWarehouse, FaArrowRight, FaArrowLeft, FaClipboardList, FaBoxes, FaMoneyBill, FaUserShield, FaBuilding } from 'react-icons/fa';


export default function MenuAhe() {
    const { token } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [solicitudes, setSolicitudes] = useState([]);

    const ConsultarSolicitudesAHE = useCallback(async () => {
        const url = '/bodega/consultarsolicitudesahe';
        setCargando(true);
        await apiService.get(url, token)
        .then((response) => {
            setSolicitudes(response.data.solicitudes);
        })
        .catch((error) => {
            console.error('Error fetching municipios:', error);
        })
        .finally(() => {
            setCargando(false);
        });
    }, [token]);
    const menuAheLinks = [
    {
        to: "/bodega/ingresos",
        tooltip: "Registrar ingreso bodega",
        icon: <FaArrowRight size={20} />,
        label: "Registrar ingreso",
        className: "btn btn-app bg-primary"
    },
    {
        to: "/bodega/salidas",
        tooltip: "Salidas bodega",
        icon: <FaArrowLeft size={20} />,
        label: "Salidas bodega",
        className: "btn btn-app bg-primary"
    },
    {
        to: "/bodega/consultaingresos",
        tooltip: "Ingresos bodega",
        icon: <FaClipboardList size={20} />,
        label: "Ingresos bodega",
        className: "btn btn-app bg-primary"
    },
    {
        to: "/bodega/consultaexistencias",
        tooltip: "Existencias bodega",
        icon: <FaBoxes size={20} />,
        label: "Existencias",
        className: "btn btn-app bg-primary"
    },
    {
        to: "/bodega/valoresayudas",
        tooltip: "Valores ayudas",
        icon: <FaMoneyBill size={20} />,
        label: "Valores ayudas",
        className: "btn btn-app bg-primary"
    },
    {
        to: "/parametros/ayudasporrol",
        tooltip: "Ayudas por rol",
        icon: <FaUserShield size={20} />,
        label: "Ayudas por rol",
        className: "btn btn-app bg-primary"
    },
    {
        to: "/parametros/ayudasxentidades",
        tooltip: "Ayudas por entidades",
        icon: <FaBuilding size={20} />,
        label: "Ayudas por entidades",
        className: "btn btn-app bg-primary"
    }
    ];
    useEffect(() => {
        ConsultarSolicitudesAHE();
    }, [ConsultarSolicitudesAHE]);
    const renderLinks = (links) => {
    return links.map((link, index) => (
        !link.hidden && (
            <NavLink
                key={index}
                to={link.to}
                className={link.className}
                data-tooltip-id="tooltiparriba"
                data-tooltip-content={link.tooltip}
            >
                {link.icon}
                <p>{link.label}</p>
            </NavLink>
        )));
    };
    
    return (
        <div className="content-wrapper">
             <SeccionPageHeader
                title="Bodega de AHE"
                idCabezaFamilia="0"
                url="/"
                nombreurl=""
                nombreform="Bodega de AHE"
            />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div className="row">
                    <div className="col-md-12 no-padding">
                        {renderLinks(menuAheLinks)}
                    </div>
                </div>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>Acciones</th>
                            <th>ID</th>
                            <th>Fecha</th>
                            <th>Solicitante</th>
                            <th>Estado</th>
                        </tr>
                    </thead>
                    <tbody>
                        {solicitudes.length === 0 ? (
                            <tr>
                                <td colSpan="5" style={{ textAlign: 'center' }}>No hay solicitudes</td>
                            </tr>
                        ) : (
                            solicitudes.map((solicitud) => (
                                <tr key={solicitud.id}>
                                    <td>
                                        <button
                                            data-tooltip-id="tooltiparriba"
                                            data-tooltip-content="Tramitar solicitud"
                                            className="btn btn-info"
                                            type="button"
                                        >
                                            Tramitar
                                        </button>
                                    </td>
                                    <td>{solicitud.id}</td>
                                    <td>{solicitud.fecha}</td>
                                    <td>{solicitud.solicitante}</td>
                                    <td>{solicitud.estado}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}